<template>
  <el-col :span="col" :offset="offset">
    <el-card class="OACard" shadow="hover">
      <div slot="header" v-if="header">
        <span class="title">{{header}}</span>
        <span v-if="required">
          (<i class="danger">*</i>为必填项)
        </span>
        <slot name="button"></slot>
      </div>
      <div class="line" v-if="header"></div>
      <div class="content">
        <slot></slot>
      </div>
    </el-card>
  </el-col>
</template>
<script>
export default {
  name: "OACard",
  data() {
    return {};
  },
  props: {
    header: {
      default: null
    },
    col: {
      default: 24
    },
    required: {
      default: null
    },
    offset: {
      default: null
    }
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss">
.OACard {
  position: relative;
  background: #fff;
  padding: 0 10px;
  margin-bottom: 10px;

  .el-card__header {
    line-height: 40px;
    padding: 0 25px;

    .title {
      color: #409eff;
      font-size: 16px;
      margin-right: 10px;
    }
  }

  .line {
    width: 3px;
    height: 17px;
    background: #409eff;
    position: absolute;
    top: 12px;
    left: 20px;
  }

  .el-card__body {
    padding: 15px;
    .content-body li {
      padding: 15px;
      cursor: pointer;
      &:hover {
        background-color: #f0f7ff;
      }
      &.active {
        background-color: #f0f7ff;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/OACard/OACard.vue